import styled from 'styled-components';
export const DrawerHeader = styled.div `
  display: flex;
  align-items: center;
  padding: 0 8px;
  justify-content: space-between;
  min-height: 56px;
  @media (min-width: 600px) {
    min-height: 64px;
  }
`;
export const PoweredByText = styled.div `
  color: ${({ theme }) => theme.fontColorMenu};
  font-size: ${({ theme }) => theme.smFontSize};
  align-self: center;
`;
export const Logo = styled.img `
  width: ${(props) => props.width || 'auto'};
  height: ${(props) => props.height || 'auto'};
`;
